import kinetic from 'jquery.kinetic'

// jQuery( '#timeline' ).kinetic({
// 	y: false,
// 	cursor: 'pointer',
// });

$('#timeline').kinetic({
  y: false,
  cursor: 'pointer'
});
